import cls from './ChildrenOnb.module.scss';
import childPurpleImg from '../../assets/images/game/children/purple_2.svg';
import childBlueImg from '../../assets/images/game/children/blue_2.svg';
import childOrangeImg from '../../assets/images/game/children/orange_2.svg';
import childPinkImg from '../../assets/images/game/children/pink_2.svg';
import childGreyImg from '../../assets/images/game/children/grey_2.svg';
import childYellowImg from '../../assets/images/game/children/yellow_2.svg';

const ChildrenOnb = () => {
  return (
    <div className={cls.childrenGroup}>
      <img alt="Child" src={childBlueImg} className={cls.childBlue} style={{ width: '74px' }} />
      <img alt="Child" src={childOrangeImg} className={cls.childOrange} style={{ width: '67px' }} />
      <img alt="Child" src={childPurpleImg} className={cls.childPurple} style={{ width: '59px' }} />
      <img alt="Child" src={childPinkImg} className={cls.childPink} style={{ width: '59px' }} />
      <img alt="Child" src={childGreyImg} className={cls.childGrey} style={{ width: '67px' }} />
      <img alt="Child" src={childYellowImg} className={cls.childYellow} style={{ width: '74px' }} />
    </div>
  );
};

export default ChildrenOnb;
